import React, { useEffect, useRef, useState } from 'react';
import { X, CalendarCheck } from '@phosphor-icons/react';

const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL;

let scriptPromise;
function loadCalendly() {
  if (window.Calendly) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://assets.calendly.com/assets/external/widget.js';
    s.async = true;
    s.onload = resolve;
    s.onerror = () => reject(new Error('Calendly failed to load'));
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export default function CalendlyModal({ open, onClose }) {
  const hostRef = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!open) return;
    setFailed(false);
    loadCalendly()
      .then(() => {
        if (hostRef.current && window.Calendly) {
          hostRef.current.replaceChildren();
          window.Calendly.initInlineWidget({ url: CALENDLY_URL, parentElement: hostRef.current });
        }
      })
      .catch(() => setFailed(true));
  }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="calendly-modal">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative w-full max-w-3xl rounded-2xl overflow-hidden shadow-2xl bg-white">
        <div className="flex items-center justify-between px-5 py-3 border-b" style={{ borderColor: '#E2E8F0' }}>
          <div className="flex items-center gap-2 font-heading font-bold" style={{ color: '#0B1120' }}>
            <CalendarCheck size={20} weight="duotone" style={{ color: '#EA580C' }} />
            Schedule a meeting with our Expert
          </div>
          <button onClick={onClose} aria-label="Close" className="p-1.5 rounded hover:bg-slate-100" data-testid="calendly-modal-close">
            <X size={18} color="#0B1120" />
          </button>
        </div>
        {failed ? (
          <div className="p-10 text-center text-sm" style={{ color: '#334155' }}>
            Couldn't load the scheduler.{' '}
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="font-semibold underline" style={{ color: '#EA580C' }}>
              Open Calendly in a new tab →
            </a>
          </div>
        ) : (
          <div ref={hostRef} style={{ minHeight: '650px', height: '70vh' }} data-testid="calendly-widget-host" />
        )}
      </div>
    </div>
  );
}

export function ScheduleExpertButton({ className, style, children, testId = 'schedule-expert-btn' }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={className} style={style} data-testid={testId}>
        {children || 'Schedule a meeting with our Expert'}
      </button>
      <CalendlyModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
